class submitEventDataReader {
  getErrors(v2Errors) {
    let concatArray = [];
    if (v2Errors && v2Errors.length > 0) {
      concatArray = concatArray.concat(v2Errors);
    }
    const errorData = [];
    concatArray.forEach((error) => {
      if (error.fieldName && error.errorCode) {
        errorData.push({type: error.fieldName, label: error.errorCode});
      }
    });
    return errorData;
  }
}

export default new submitEventDataReader();
